import React from 'react';
import { Notebook } from '../../services/notebook-service/src/types';

interface NotebookResultsProps {
  notebook: Notebook;
}

export const NotebookResults: React.FC<NotebookResultsProps> = ({ notebook }) => {
  // Aggregate all outputs from cells
  const results = notebook?.cells?.filter(cell => cell.output);

  const handleExport = () => {
    // TODO: Export all results as CSV/JSON
    alert('Export not implemented yet.');
  };

  return (
    <div className="notebook-results">
      <h3>Notebook Results</h3>
      <button onClick={handleExport}>Export Results</button>
      {results?.length === 0 ? <div>No results yet.</div> : (
        results?.map(cell => (
          <div key={cell.id} className="cell-result-block">
            <strong>{cell.type.toUpperCase()} Cell Result:</strong>
            <pre>{JSON.stringify(cell.output, null, 2)}</pre>
          </div>
        ))
      )}
    </div>
  );
}; 